module.exports = __webpack_public_path__ + "static/service-5-a5bee6ad9d9be5670d3e968cbdf58109.jpg";